import styled from "@emotion/styled";

import { Button, Icon, IndicatorButton, SkiliticsIcon } from "@skilitics/designer-ui-components";
import { useFormatMessage, type FormatMessages } from "@skilitics/localization";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: 100%;
  width: 100%;
`;

const Section = styled.div`
  display: flex;
  gap: 4px;
  height: 100%;
  padding: 0 4px;

  &:not(:first-of-type) {
    border-inline-start: 1px solid ${({ theme }) => theme.outline};
  }
  &:not(:last-of-type) {
    border-inline-end: 1px solid ${({ theme }) => theme.outline};
  }
`;

const CloseTriggersButton = styled(Button)`
  font-size: ${({ theme }) => theme.fontSizeSmall};
  border-radius: 0;
  .fa-icon-wrapper {
    margin-right: 5px;
  }
`;

type Props = {
  orientation: "horizontal" | "vertical";
  onOrientationChange: () => void;
  onClose?: () => void;
};

export const ResponseEditorViewBar = ({ orientation, onOrientationChange, onClose }: Props) => {
  const formatMessage = useFormatMessage(formatStrings);

  return (
    <Container>
      <Section>
        <CloseTriggersButton onClick={onClose} color="inherit">
          <Icon icon="times" /> {formatMessage("closeTriggersButton")}
        </CloseTriggersButton>
      </Section>
      <Section>
        <IndicatorButton
          key="orientation"
          state="off"
          onToggle={() => onOrientationChange()}
          tooltip={formatMessage("orientation")}
          data-test="change-orientation-button"
        >
          <SkiliticsIcon
            icon={orientation === "horizontal" ? "layer-horizontal-flow" : "layer-vertical-flow"}
            size={18}
          />
        </IndicatorButton>
      </Section>
    </Container>
  );
};

const formatStrings = {
  orientation: {
    en: "Change orientation of conditions/effects area.",
  },
  closeTriggersButton: {
    en: "Close Triggers Editor",
  },
} satisfies FormatMessages;
